/*
 * @Author:
 * @Description:
 * @Date: 2025-06-05 19:55:45
 * @LastEditors: Please set LastEditors
 * @FilePath: /rhcn-merchant-web/src/language/networkApplication/zh-cn.js
 */
export default {
  networkApplication: {
    title: '入网申请',
    validateBusiness: '验证您的业务',
    companyDetails: {
      title: '公司详情',
      descript1: '公司详情',
      descript2: 'Onerway 收集该信息的目的是更好的服务您的业务。',
      legalBusinessName: '法定公司名称',
      tradingName: '公司营业名称/曾用名',
      registrationNumber: '公司注册号码',
      registrationDate: '公司注册日期',
      registrationAddress: '公司注册地址',
      location: '国家/地区',
      areaOrCity: '城市/区域',
      district: '郡/县/区',
      streetAddress: '街道地址',
      detailedAddress: '详细地址',
      postalCode: '邮政编码',
      businessType: '公司类型',
      operatingAddress: '公司办公地址',
      selectCountry: '请选择国家/地区',
      corporateEmail: '公司联系邮箱',
      corporatePhone: '公司联系电话',
      wechat: '公司联系微信号',
      skype: '公司联系Skype',
      uploadCertificates: '上传公司资料',
      uploadLimit: '上传限制',
      continue: '继续',
      inputError: '请输入有效字符',
      emailError: '请输入有效的邮箱地址',
      phoneError: '请输入有效的电话号码',
      required: '必填',
      certificate_of_incorporation: '公司注册证书',
      business_registration_certificate: '公司营业登记证书',
      form_NNC1_NAR1: '公司 NNC1/NAR1',
      form_IN01: '公司注册IN01文件',
      // 公司更名证明
      certificate_of_change_name: '公司更名证明',
      // 办公地址证明
      proof_of_address: '办公地址证明',
      // 股权架构说明
      proof_of_shareholding_structure: '股权架构说明',

    },
    companyOwner: {
      title: '公司关联人',
      descript1: '公司关联人',
      descript2: '我们需要收集并验证在您的公司拥有主要所有权（拥有25%或更多）的任何关联人的信息。',
      owner: '关联人',
      delete: '删除',
      name: '法定名称',
      namePlaceholder: '请输入法定名称',
      type: '关联人类型',
      typePlaceholder: '请选择关联人类型',
      birthDate: '出生日期',
      birthDatePlaceholder: '请选择出生日期',
      // 通讯地址
      communicationAddress: '通讯地址',
      location: '国家/地区',
      locationPlaceholder: '请选择国家',
      areaOrCity: '城市/区域',
      areaOrCityPlaceholder: '城市/区域',
      district: '郡/县/区',
      districtPlaceholder: '郡/县/区',
      streetAddress: '街道地址',
      streetAddressPlaceholder: '街道地址',
      detailedAddress: '详细地址',
      detailedAddressPlaceholder: '详细地址',
      postalCode: '邮政编码',
      postalCodePlaceholder: '邮政编码',
      idIssuingCountry: '证件发出国家/地区',
      idIssuingCountryPlaceholder: '请选择证件发出国家/地区',
      idType: '证件类型',
      idTypePlaceholder: '请选择证件类型',
      idNumber: '证件号码',
      idNumberPlaceholder: '请输入证件号码',
      shareholding: '持股比例',
      shareholdingPlaceholder: '请输入持股比例',
      uploadDocuments: '上传证件影像',
      addOwner: '添加关联人',
      continue: '继续',
      inputError: '请输入有效字符',
      required: '必填',
      identificationDocumentFront: '政府发出的身份证明文件正面（人像面）',
      identificationDocumentBack: '政府发出的身份证明文件反面',
      proofOfAddress: '通讯地址证明',
      lastPositionOrRelationshipName: '关联人类型',
      idIssuingCountryOrRegion: '证件发出国家/地区',
      identificationType: '证件类型',
      identificationNumber: '证件号码',
      shareholdingPercentage: '持股比例',
      director: '董事',
      legalRepresentative: '法人',
      ultimateBeneficialOwner: '最终受益所有人（UBO）',
      proxyActionPerson: '代理行动人（PPTA）',
      // 身份证
      idType_idCard: '身份证',
      // 驾照
      driverLicense: '驾照',
      // 护照
      passport: '护照',
      // 删除确认相关
      deleteConfirmTitle: '确认删除',
      deleteConfirmContent: '确定要删除该关联人吗？',
      deleteSuccessMessage: '关联人删除成功',
    },
    payoutBusinessInfo: {
      title: '收单业务信息',
      descript1: '收单业务信息',
      descript2: 'Onerway 收集该信息的目的是更好的评估并服务您的业务。',
      websiteUrl: '业务网站',
      operationalHistory: '已运营时间',
      platformType: '网站类型',
      primaryDomain: '原始网址',
      primaryDomainPlaceholder: '请输入原始网址',
      merchantCategory: '所属行业',
      merchantCategoryPlaceholder: '请选择所属行业',
      monthlyTransactionAmount: '月均交易额（USD）',
      averageTransactionAmount: '笔均交易额（USD）',
      chargebackRatio: '拒付率',
      refundRatio: '退款率',
      targetMarkets: '业务面向市场',
      businessVerificationDocuments: '上传业务证明',
      businessWebsite: '业务网站',
      businessWebsitePlaceholder: 'www.example.com',
      durationOfOperation: '已运营时间',
      businessWebsiteType: '网站类型',
      websiteDefaultDomain: '原始网址',
      websiteDefaultDomainPlaceholder: '请输入原始网址',
      industryCategory: '所属行业',
      industryCategoryPlaceholder: '请选择所属行业',
      monthlyTradingVolume: '月交易额（USD）',
      monthlyDisputeRate: '拒付率',
      monthlyRefundRate: '退款率',
      market: '业务面向市场',
      uploadBusinessProofs: '上传公司营业登记证书',
      hottest: '热门行业',
      otherMarket: '其他行业',
      continue: '继续',
      average_transaction_amount: '笔均交易额（USD）',
      // 办公室照片（需体现主体名称）
      officePhotos: '办公室照片（需体现主体名称）',
      // 仓库货品存货照片
      warehouseInventoryPhotos: '仓库货品存货照片（实物电商必传）',
      // 近6个月的历史交易表格
      transactionTableForTheLast6Months: '近6个月的历史交易表格',
      // 原始交易数据
      originalTransactionData: '原始交易数据',
    },
    bankAccount: {
      title: '银行账户',
      descript1: '银行账户',
      descript2: '添加您的银行账户以接收提现。提现是指从 Onerway 向您的银行账户转账。',
      accountHolderName: '账户持有者名称',
      accountHolderNamePlaceholder: '须与法定公司名称一致',
      chooseYourBank: '开户银行',
      bankBranchAddress: '开户银行地址',
      bankingAccountVerificationDocuments: '上传证明材料',
      bankAddress: '开户银行',
      bankAddressPlaceholder: '搜索您的开户银行/ SWIFT Code',
      registeredAddress: '注册地址',
      location: '开户银行地址',
      locationPlaceholder: '请选择所在地',
      areaOrCity: '城市/区域',
      areaOrCityPlaceholder: '请输入城市/区域',
      district: '郡/县/区',
      districtPlaceholder: '请输入郡/县/区',
      streetAddress: '街道地址',
      streetAddressPlaceholder: '请输入街道地址',
      detailedAddress: '详细地址',
      detailedAddressPlaceholder: '请输入详细地址',
      postalCode: '邮政编码',
      postalCodePlaceholder: '请输入邮政编码',
      settlementCurrency: '币种',
      settlementCurrencyPlaceholder: '请选择币种',
      accountNumber: '账号',
      accountNumberPlaceholder: '请输入账号',
      confirmAccountNumber: '确认账号',
      confirmAccountNumberPlaceholder: '请确认账号',
      uploadDocuments: '上传文件',
      continue: '继续',
      inputError: '请输入有效字符',
      required: '此字段为必填项',
      atLeast3SwiftCodeTips: '请输入至少3个SWIFT代码字符',
      noDataText: '暂无数据',
      // 开户证明
      proofOfBankAccount: '银行开户证明',
      // 银行对账单
      bankStatements: '银行账单',
      confirmAccountNumber_label_GB: '确认账号',
    },
    status: {
      title: '审核并确认',
      content: '', // 请检查并提交您的申请
      companyType: '公司类型',
      companyDetails: '公司详情',
      companyRepresentative: '公司代表',
      companyOwner: '公司关联人',
      websiteOrApplication: '网站/应用',
      bankAccount: '银行账户',
      edit: '编辑',
      submitAgreementTips: '点击"提交申请"，即表示您同意我们的<a href="#" target="_blank">服务条款</a>和<a href="#" target="_blank">隐私政策</a>。',
      submitAgreement: '提交申请',
      applicationSubmitted: '申请已提交',
      applicationSubmittedContent: '您的申请已成功提交。',
      applicationSubmittedTips: '我们将在1-2个工作日内审核您的申请并与您联系。',
      required: '必填',
      warning: '警告',
    },
    saveSuccess: '保存成功',
    submitSuccess: '提交成功',
    paymentMethods: {
      visa: '维萨卡',
      mastercard: '万事达卡',
    },
    //
    //     waiting 待审核,

    // processing 审核中,

    // pass 审核通过,

    // fail 审核不通过,

    // cancel 取消/撤销,

    // unnecessary 无需审核,

    // refuse 拒绝,

    // suspend 挂起
    // 工单状态
    approveStatus: {
      waiting: '待审核',
      processing: '审核中',
      pass: '审核通过',
      fail: '已拒绝',
      cancel: '取消/撤销',
      unnecessary: '无需审核',
      refuse: '拒绝',
      suspend: '挂起',
      status: '审批状态',
      orderNumber: '工单编号',
      merchantNo: '商户号',
      merchantName: '商户名称',
      approveComments: '审批意见',
    },
    guideForCooperate: {
      title: '欢迎使用Onerway的支付服务',
      introText: '在开始填写信息之前，我们希望您了解我们的定价结构和接下来的合作流程，以确保您对我们的服务有清晰的认识。',
      pricing: {
        title: '定价',
        processingFee: {
          title: '固定处理费',
          value: '$ 0.30',
          desc: '退款处理费、拒付处理费等另计',
        },
        merchantFee: {
          title: '商户手续费',
          value: 'Interchange++0.50%',
          desc: '包含卡网络的Interchange和Scheme费用。ONERWAY额外收取0.50%的服务费。',
        },
      },
      process: {
        title: '流程：',
        steps: {
          // Fill Out Information
          fillInfo: '填写信息',
          review: '审核',
          signContract: '签署合同',
          systemConfig: '系统配置',
          startUse: '开始使用',
        },
      },
      agreement: '点击"继续"按钮，即表示您已阅读并同意上述信息。',
      continue: '继续',

    },
    extraDocument: {
      extraDocument1: '附加材料1',
      extraDocument2: '附加材料2',
      extraDocument3: '附加材料3',
      extraDocument4: '附加材料4',
      extraDocument5: '附加材料5',
      extraDocument6: '附加材料6',
      extraDocument7: '附加材料7',
      extraDocument8: '附加材料8',
      extraDocument9: '附加材料9',
      extraDocument10: '附加材料10',
    },
    validateError: {
      // 仅支持英文字母、阿拉伯数字、空格
      onlySupportEnglishLettersAndNumbersAndSpaces: '仅支持英文字母、阿拉伯数字、空格',
      // 两次输入的银行账户不一致
      confirmAccountNumberNotMatch: '两次输入的银行账户不一致',
    },
  },
};
